import { ReactNode, forwardRef, memo } from "react";

import "./MapToolbar.scss";

interface MapToolbarProps {
  itemCount?: number;
  children: ReactNode;
  className?: string;
}

function MapToolbar(
  { itemCount = 12, children, className = "" }: MapToolbarProps,
  ref: React.Ref<HTMLDivElement>
) {
  return (
    <div ref={ref} className={`MapToolbar ${className}`}>
      <div className="backpane" />
      <div
        className="wrapper"
        style={{
          gridTemplateColumns: `repeat(${itemCount}, max-content)`
        }}>
        {children}
      </div>
    </div>
  );
}

export default memo(forwardRef(MapToolbar));
